// extracted by mini-css-extract-plugin
module.exports = {"menu-button":"Details_menu-button__2y3dg","stuff-container":"Details_stuff-container__208iy","faq-container":"Details_faq-container__28HvH","pad":"Details_pad__oDB-8"};